/** Color Mood registry — the emotional temperature of the palette. */

export const COLOR_MOODS = [
  { id: 'luxury-gold', name: 'Luxury Gold' },
  { id: 'warm', name: 'Warm' },
  { id: 'cool', name: 'Cool' },
  { id: 'earthy', name: 'Earthy' },
  { id: 'corporate-blue', name: 'Corporate Blue' },
  { id: 'nature', name: 'Nature' },
  { id: 'ocean', name: 'Ocean' },
  { id: 'dark', name: 'Dark' },
  { id: 'light', name: 'Light' },
  { id: 'pastel', name: 'Pastel' },
  { id: 'neon', name: 'Neon' },
  { id: 'festive', name: 'Festive' },
  { id: 'monochrome', name: 'Monochrome' },
  { id: 'sunset', name: 'Sunset' },
];
